import { Api } from 'utils';

class CorporatePaymentService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/corporate-payments/get',params),
		getPaymentMethods: async (params?: any) => Api.createResponse('admin/corporate-payments/payment-methods',params),
		save: async (params?: any) => Api.createResponse('admin/corporate-payments/save',params)
	}

}

export default CorporatePaymentService;